import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

function ListAgents({ data, cellComponent, headers = [] }) {
  const { t } = useTranslation();

  const normalize = (text = "") =>
    text
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

  const getStatusColor = (status) => {
    const normalized = normalize(status);
    const statusColors = {
      disponible: "#4CAF50",
      offline: "#9E9E9E",
      "no disponible": "#1371b5",
      atencion: "#b78804",
      "en ruta": "#6024c7",
    };
    return statusColors[normalized] || "#9E9E9E";
  };

  const columnWidth =
    headers.length > 0 ? `${100 / headers.length}%` : "auto";

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
      }}
    >
      {data && data.length > 0 ? (
        <>
          {headers.length > 0 && (
            <Table
              sx={{
                tableLayout: "fixed",
                width: "100%",
                borderCollapse: "separate",
              }}
              size="small"
            >
              <TableHead>
                <TableRow>
                  {headers.map((header, idx) => (
                    <TableCell
                      key={idx}
                      sx={{
                        width: columnWidth,
                        fontWeight: 600,
                        fontFamily: "Raleway, sans-serif",
                        fontSize: "0.9rem",
                        backgroundColor: "#f0f0f0",
                        padding: "8px",
                      }}
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
            </Table>
          )}

          <TableContainer
            sx={{
              flex: 1,
              minHeight: 0,
              overflow: "auto",
              scrollbarGutter: "stable",
            }}
          >
            <Table sx={{ tableLayout: "fixed", width: "100%" }} size="small">
              <TableBody>
                {data.map((item, index) => (
                  <TableRow
                    key={item._id || index}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#F5F5F5" : "white",
                    }}
                  >


                    {/* 💡 CORRECCIÓN AQUÍ: Recorremos los headers y pasamos (item, header) */}
                    {headers.map((header, idx) => (
                      <TableCell
                        key={idx}
                        sx={{ width: columnWidth, padding: "8px" }}
                      >
                        {cellComponent(item, header)}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      ) : (
        <Typography
          variant="h3"
          sx={{
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            position: "absolute",
            color: "#9E9E9E",
            fontFamily: "Raleway, sans-serif",
            fontSize: "1rem",
            textAlign: "center",
          }}
        >
          No se encontraron ajustadores
        </Typography>
      )}
    </div>
  );
}

export default ListAgents;